import {useState} from 'react'
import { useNavigate } from 'react-router-dom'

type ISearchProducts = {
  _handleSearch: (data: any) => void,
  loading: boolean
}

const Search = (props: ISearchProducts) => {
  const {loading, _handleSearch } = props
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    showMine: false,
    search: '',
  })
  
  return (
    <div className='card p-10'>
      <div className='row fs-4 fw-bold'>
        <div className='col-12 col-lg-5'>
          <input
            type='text'
            className='form-control'
            placeholder='Buscar por título'
            value={filters.search}
            onChange={(e) =>
              setFilters((prevState) => ({
                ...prevState,
                search: e.target.value || '',
              }))
            }
          />
        </div>
        {/* <div className='col-12 col-md-7 col-xl-2 mt-12'>
          <input
          type='checkbox'
          id='show-mine'
          className='form-check-input'
          checked={filters.showMine}
          onChange={(e) =>
          setFilters((prevState) => ({
            ...prevState,
            showMine: e.target.checked,
            }))
            }
            />{' '}
            Ver mis productos
            </div> */}
        <div className='col-12 col-lg-3 mt-4 mt-lg-0'>
          <button
            type='button'
            className='btn btn-sm fw-bold btn-primaryamsm me-2 w-100 w-lg-auto'
            disabled={loading}
            onClick={() => _handleSearch(filters)}
          >
            <i className='ki-duotone ki-search-list fs-2x text-white'>
              <span className='path1'></span>
              <span className='path2'></span>
              <span className='path3'></span>
            </i>{' '}
            Buscar
          </button>
        </div>

        <div className='col-12 col-lg-4 text-lg-end mt-4 mt-lg-0'>
          <button
            type='button'
            className='btn btn-sm fw-bold btn-success ml-2 w-100 w-lg-auto'
            disabled={loading}
            onClick={() => {navigate('/marketplace/my-notices')}}
          >
            <i className="ki-duotone ki-abstract-14 fs-2x text-white">
              <span className="path1"></span>
              <span className="path2"></span>
            </i> Mis avisos
          </button>
        </div>
      </div>

    </div>
  )
}

export default Search
